import React from 'react'

interface Props {
  steps: Array<{
    title: string
    desc?: string
    status: 'done' | 'doing' | 'pending'
  }>
}

const ICON: Record<string, string> = { done: '✓', doing: '●', pending: '○' }

export const ProgressSteps: React.FC<Props> = ({ steps }) => (
  <ol className="aiClerk-att-progress">
    {steps.map((s, i) => (
      <li
        key={i}
        className={`aiClerk-att-progress__item aiClerk-att-progress__item--${s.status}`}
      >
        <span className="aiClerk-att-progress__icon">{ICON[s.status]}</span>
        <div className="aiClerk-att-progress__body">
          <div className="aiClerk-att-progress__title">{s.title}</div>
          {s.desc && <div className="aiClerk-att-progress__desc">{s.desc}</div>}
        </div>
        {/* 竖向 timeline 连接线 —— 视觉对齐 TaskStatusBlock */}
        {i < steps.length - 1 && <div className="aiClerk-att-progress__line" />}
      </li>
    ))}
  </ol>
)
